import { Injectable } from '@angular/core';
import { Http, Headers, Response,RequestOptions} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Router, ActivatedRoute,NavigationEnd,Params } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthenticationService {
    backendUrl:any;
    TOKEN : any;
    headers : any;
    options : any;
    constructor(private http: Http,private router: Router) { 
        this.backendUrl=window.location.origin
        if(!environment.production)
            this.backendUrl=environment.url
        this.backendUrl+="/apis"
        
    }    

    login(useremail: string, password: string,backendUrl:any,partnerId:any) {
        this.TOKEN = localStorage.getItem('login_token')
        this.headers = new Headers({'Content-Type': 'application/json'});  
        this.headers.append('Authorization',this.TOKEN)
        this.options = new RequestOptions({headers: this.headers});
        return this.http.post(this.backendUrl+'/login',JSON.stringify({'useremail': useremail,'password': password ,'owner_id':partnerId}),this.options)
            .map((response: Response) => {
                 console.log(response);
                 //let user = response.json();
                 var token = response.headers.get('x-auth-token');
                if (token) {
                          localStorage.setItem('id_token', token);
                          localStorage.removeItem('login_token');
                }
                // console.log(token);
                return response.json();
            })
    }

    logout() {
        // remove user from local storage to log user out
          localStorage.removeItem('id_token');
          localStorage.removeItem('currentUser');
          localStorage.removeItem('pagedetails');
          localStorage.removeItem('access_token');
          this.router.navigate(['/login']);
    }
}


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_services/authentication.service.ts